import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    const path = location.pathname || '';
    if (path.startsWith('/dashboard/platform')) {
      const full = `${path}${location.search || ''}${location.hash || ''}`;
      return <Navigate to={`/login?type=platform&redirect=${encodeURIComponent(full)}`} replace />;
    }
    const isBusinessContext = path.startsWith('/dashboard/business')
      || path.startsWith('/account-settings')
      || path.startsWith('/personnel')
      || path.startsWith('/services')
      || path.startsWith('/categories');
    const to = isBusinessContext ? '/login?type=business' : '/login?type=customer';
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 